import { computed, type ComputedRef } from 'vue'

import type { ApprovalStage } from '@/types/workflow'

import {
  getApprovalFeedbackPlaceholder,
  getPreviousApprovalStage,
  getRevisionActionLabel,
} from './approvalFlow'

interface UseApprovalFlowPolicyOptions {
  currentStage: ComputedRef<ApprovalStage>
  pendingApprovalStage: ComputedRef<ApprovalStage | null>
  reviewingPreviousStage: ComputedRef<boolean>
}

export function useApprovalFlowPolicy(options: UseApprovalFlowPolicyOptions) {
  const actionableApprovalStage = computed(() => options.pendingApprovalStage.value || options.currentStage.value)
  const revisionActionStage = computed(() => options.reviewingPreviousStage.value ? options.currentStage.value : actionableApprovalStage.value)
  const revisionTargetStage = computed(() => options.reviewingPreviousStage.value ? options.currentStage.value : getPreviousApprovalStage(actionableApprovalStage.value))
  const revisionActionLabel = computed(() => getRevisionActionLabel(revisionActionStage.value))
  const reviewFeedbackPlaceholder = computed(() => getApprovalFeedbackPlaceholder(revisionActionStage.value))

  return {
    actionableApprovalStage,
    revisionActionStage,
    revisionActionLabel,
    revisionTargetStage,
    reviewFeedbackPlaceholder,
  }
}